module.exports = __webpack_public_path__ + "img/SB.dc75c2d7.png";